interface AvatarProps {
  src?: string | null;
  name: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-14 w-14 text-base',
};

function initials(name: string): string {
  return name
    .split(' ')
    .slice(0, 2)
    .map((n) => n[0] ?? '')
    .join('')
    .toUpperCase();
}

export function Avatar({ src, name, size = 'md', className = '' }: AvatarProps) {
  if (src) {
    return (
      <img
        src={src}
        alt={name}
        className={[
          'rounded-full object-cover ring-2 ring-white',
          sizeClasses[size],
          className,
        ].join(' ')}
      />
    );
  }

  return (
    <div
      className={[
        'rounded-full bg-primary/10 text-primary font-semibold',
        'flex items-center justify-center ring-2 ring-white',
        sizeClasses[size],
        className,
      ].join(' ')}
      aria-label={name}
    >
      {initials(name)}
    </div>
  );
}
